// prismのcss読み込み
require("prismjs/themes/prism-tomorrow.css")
require("prismjs/plugins/command-line/prism-command-line.css")

// remark link beautifyのcss読み込み
import 'gatsby-remark-link-beautify/themes/notion.css';